<div id="kt_body" class="auth-bg">
    <div class="d-flex flex-column flex-root">
        <div class="d-flex flex-column flex-center flex-column-fluid p-10">
            <img src="/assets/media/illustrations/sketchy-1/18.png" alt="" class="mw-100 mb-10 h-lg-450px" />
            <h1 class="fw-bold mb-10" style="color: #A3A3C7">Sayfa bulunamadı</h1>
            <a routerLink="/" class="btn btn-primary">Anasayfaya Dön</a>
        </div>
    </div>
</div>